module.exports = __webpack_public_path__ + "static/media/onlineOrder2.f2c68405.png";